/**
 * Calculations title view.
 * 
 * @package Ninja Forms builder
 * @subpackage App
 * @copyright (c) 2024 WP Ninjas
 * @since 3.8
 */
define( 'views/advanced/drawer/calculationsTitle',[], function() {
	var view = Marionette.ItemView.extend({
		tagName: 'div',
		template: '#tmpl-nf-drawer-content-edit-settings-title-calculations',

		templateHelpers: function () {
	    	return {
				renderDocLink: function() {
	    			var currentDomain = nfRadio.channel( 'app' ).request( 'get:currentDomain' );
					var domainID = currentDomain.get( 'id' );
	    			var type = nfRadio.channel( domainID ).request( 'get:type', this.type );
					return '<a class="nf-external-info" href="https://ninjaforms.com/docs/calculations/" target="_blank"></a>';
				}
			};
		},
	});

	return view;
} );
